<template>
  <div>
    <v-card
      style="width:100% ; height:10%;float:left; "
    >
      <universal-input
        v-model="reportFilter"
        label="Report Type"
        :config="reportFilterConfig"
      >
      </universal-input>

      <v-card-text
        v-if="reportFilter == 1"
        style="height:100vh"
      >
        <LockerExcel>
        </LockerExcel>
      </v-card-text>

      <v-card-text
        v-else-if="reportFilter == 2"
        style="height:100vh"
      >
        <TransferBookingExcel>
        </TransferBookingExcel>
      </v-card-text>

      <v-card-text
        v-else-if="reportFilter == 3"
        style="height:100vh"
      >
        <SalesReportExcel>
        </SalesReportExcel>
      </v-card-text>

      <v-card-text
        v-else-if="reportFilter == 4"
        style="height:100vh"
      >
        <DailySalesRegisterReportExcel>
        </DailySalesRegisterReportExcel>
      </v-card-text>

      <v-card-text
        v-else-if="reportFilter == 5"
        style="height:100vh"
      >
        <CommissionReportExcel>
        </CommissionReportExcel>
      </v-card-text>
    </v-card>
  </div>
  <!-- </div> -->
</template>

<script setup>

import { ref, onMounted, computed, toRefs, watch, onBeforeMount } from 'vue'
import LockerExcel from './Excel/LockerExcel.vue'
import SalesReportExcel from './Excel/SalesReportExcel.vue'
import TransferBookingExcel from './Excel/TransferBookingExcel.vue'

import DailySalesRegisterReportExcel from './Excel/DailySalesRegisterReportExcel.vue'
import UniversalInput from '@/components/CRUD/UniversalInput.vue'
import { ExcelReportList as FetchExcelReportList } from '@/api/user'
import CommissionReportExcel from './Excel/CommissionReportExcel.vue'

const reportFilter = ref(0)
const reportList = ref([])
const reportFilterConfig = ref({
  name: 'reportFilter',
  label: 'Report Type',
  type: {
    name: 'autocomplete',
    items: reportList.value,
  },
})

onMounted(() => {
  callExcelReportListAPI()
})

function callExcelReportListAPI() {
  // salesList.value = []

  const templist = []

  FetchExcelReportList().then(response => {
    console.log('response', response)

    for (let index = 0; index < response.data.items.length; index += 1) {
      const item = response.data.items[index]
      console.log('callSalesListAPI', item)
      if (item) {
        templist.push({
          id: item.id,
          label: item.action,
        })
      }
    }

    reportList.value = templist
    console.log('reportList.value', reportList.value)

    reportFilterConfig.value = {
      name: 'reportFilter',
      label: 'Report Type',
      type: {
        name: 'autocomplete',
        items: reportList.value,
      },

    }
  })

  // console.log('salesList.value', salesList.value)
}

</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>

<style scoped>
#spreadsheet {
  width: 100%;
  height: 600px;
}
</style>
